import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { ROUTE_DASHBOARD } from 'js/constants/pathnames';

import BrandMark from '../elements/brand/BrandMark';

import styles from './NoRouteMatchView.module.css';

const NoRouteMatchView = () => {
  return (
    <div className={styles.rootContainer}>
      <div className={styles.contentContainer} data-testid="error-screen">
        <div className={styles.logoOuterContainer}>
          <div className={styles.logoInnerContainer}>
            <BrandMark animated={true} />
          </div>
        </div>
        <div className={styles.textContainer}>
          <h1 className={styles.heading}>Uh oh! Looks like we sent you the wrong way.</h1>
          <p className={styles.subheading}>Let us guide you back home!</p>
          <div>
            <Link to={ROUTE_DASHBOARD}>
              <button className={classnames(styles.buttonCta, styles.buttonPrimary)}>
                &larr; Back to Home
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoRouteMatchView;
